//初始化数据

const state = {
    loginInfo: null,
    roleCode: null,
    token: null,
    createUid: null,
    dialogFormVisible: false,
    isUpload: true,
    drawer: false,
    powers: null,
    loveList: [],
    fileList: null,
    atlasId: null,
    libId: null,
    isMobile: false,

    //错误图片
    errorList: null,

    //获取移动端上传到期时间
    expirationTime: null,
    //全屏查看图片
    bigImage: false,

    isGoLogin: false,
    isChangePsw: false
}

//getter
const getters = {
    loginInfo: function(state) {
        if (!state.loginInfo) {
            state.loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
        }
        return state.loginInfo
    },
    powers: function(state) {
        if (!state.powers) {
            state.powers = JSON.parse(localStorage.getItem('powers'));
        }
        return state.powers
    },
    roleCode: function(state) {
        if (!state.roleCode) {
            state.roleCode = JSON.parse(sessionStorage.getItem('roleCode'))
        }
        return state.roleCode
    },
    token: function(state) {
        if (!state.token) {
            if (typeof(localStorage.getItem('token')) == 'string') {
                state.token = JSON.parse(localStorage.getItem('token'))
            } else {
                state.token = localStorage.getItem('token')
            }
        }
        return state.token
    },
    createUid: function(state) {
        if (!state.createUid) {
            state.createUid = JSON.parse(localStorage.getItem('createUid'))
        }
        return state.createUid
    },
}

//action
const actions = {
    setLoginInfo({ commit }, u) {
        commit('SET_LOGININFO', u)
    },
    setPowers({ commit }, u) {
        commit('SET_POWERS', u)
    },
    setRoleCode({ commit }, u) {
        commit('SET_ROLECODE', u)
    },
    setToken({ commit }, u) {
        commit('SET_Token', u)
    },
    setCreateUid({ commit }, u) {
        commit('SET_CreateUid', u)
    },
    setDialogFormVisible({ commit }, u) {
        commit('SET_DialogFormVisible', u)
    },
    setIsUpload({ commit }, u) {
        commit('SET_IsUpload', u)
    },
    setDrawer({ commit }, u) {
        commit('SET_Drawer', u)
    },
    setFileList({ commit }, u) {
        commit('SET_FileList', u)
    },
    setAtlasId({ commit }, u) {
        commit('SET_AtlasId', u)
    },
    setLibId({ commit }, u) {
        commit('SET_LibId', u)
    },
    setSidebarUrlList({ commit }, u) {
        commit('SET_SIDEBARURLLIST', u)
    },
    setLoveList({ commit }, u) {
        commit('SET_LoveList', u)
    },
    setIsMobile({ commit }, u) {
        commit('SET_IsMobile', u)
    },
    setExpirationTime({ commit }, u) {
        commit('SET_ExpirationTime', u)
    },
    removeUrlList({ commit }, u) {
        commit('REMOVE_URLLIST', u)
    },
    setErrorList({ commit }, u) {
        commit('SET_ErrorList', u)
    },
    setIsGoLogin({ commit }, u) {
        commit('SET_IsGoLogin', u)
    },
    setIsChangePsw({ commit }, u) {
        commit('SET_IsChangePsw', u)
    },
}

//mutation
const mutations = {
    SET_LOGININFO(state, i) {
        state.loginInfo = i;
        localStorage.setItem('loginInfo', JSON.stringify(i))
    },
    SET_POWERS(state, i) {
        state.powers = i;
        localStorage.setItem('powers', JSON.stringify(i))
    },
    SET_ROLECODE(state, i) {
        state.roleCode = i;
        sessionStorage.setItem('roleCode', JSON.stringify(i))
    },
    SET_Token(state, i) {
        state.token = i;
        localStorage.setItem('token', JSON.stringify(i))
    },
    SET_CreateUid(state, i) {
        state.createUid = i;
        localStorage.setItem('createUid', JSON.stringify(i))
    },
    SET_DialogFormVisible(state, i) {
        state.dialogFormVisible = i;
    },
    SET_IsUpload(state, i) {
        state.isUpload = i;
    },
    SET_Drawer(state, i) {
        state.drawer = i;
    },
    SET_LoveList(state, i) {
        state.loveList = i;
    },
    SET_IsMobile(state, i) {
        state.isMobile = i;
    },
    SET_FileList(state, i) {
        state.fileList = i;
    },
    SET_ExpirationTime(state, i) {
        state.expirationTime = i;
    },
    SET_AtlasId(state, i) {
        state.atlasId = i;
    },
    SET_LibId(state, i) {
        state.libId = i;
    },
    SET_ErrorList(state, i) {
        state.errorList = i
    },
    SET_BigImage(state, i) {
        state.bigImage = i
    },
    SET_IsGoLogin(state, i) {
        state.isGoLogin = i
    },
    SET_IsChangePsw(state, i) {
        state.isChangePsw = i
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
};